export default __webpack_public_path__ + "static/media/Larsseit.a46e127f.ttf";